import { Link } from "react-router-dom";
import { LEGAL_DISCLAIMER } from "../lib/categories";
import { Mail, ArrowRight } from "lucide-react";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="border-b border-[#E0D8CE]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <div className="font-mono-label text-[#4A7A3D] mb-3">À propos</div>
          <h1 className="font-display text-5xl md:text-7xl leading-[1.0]">Rwana Bizin Lega.</h1>
          <p className="font-quote text-2xl text-[#4B4B48] mt-6 leading-snug">
            « Une plateforme indépendante d'information sur le cannabis à l'île Maurice. »
          </p>

          <div className="mt-12 space-y-6 text-lg leading-[1.8]">
            <p>
              Le 17 octobre 2024, après plusieurs années de recherches, de rencontres, d'échanges entre experts et citoyens, le mouvement <strong>Rwana Bizin Lega</strong> est officiellement né. L'objectif&nbsp;: porter dans le débat public mauricien une parole adulte, documentée et apaisée sur le cannabis.
            </p>
            <p>
              Nous sommes un collectif pluridisciplinaire&nbsp;: experts en politique des drogues, travailleurs sociaux, économistes, juristes, scientifiques, médecins, intellectuels, artistes et usagers. Aucun de nous ne fait l'apologie de la consommation. Tous, nous demandons un cadre légal réformé, fondé sur la science et le respect des droits humains.
            </p>
            <p>
              Nos contenus sont produits selon une charte éditoriale stricte&nbsp;: chaque article est vérifié, sourcé, et soumis à une double relecture. La science est notre boussole. La nuance est notre méthode.
            </p>
          </div>
        </div>
      </section>

      <section className="border-b border-[#E0D8CE] bg-[#F5EFEB]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="font-mono-label text-[#4A7A3D] mb-3">Nos valeurs</div>
          <h2 className="font-display text-4xl md:text-5xl mb-10 leading-tight">Quatre principes intangibles.</h2>
          <div className="grid md:grid-cols-2 gap-x-10 gap-y-8">
            {[
              { t: "Évidence-based", d: "Tout repose sur des sources scientifiques peer-reviewed et des données vérifiables." },
              { t: "Droits humains", d: "La dignité de chaque personne, qu'elle consomme ou non, est non-négociable." },
              { t: "Santé publique", d: "Une régulation intelligente protège mieux qu'une prohibition aveugle." },
              { t: "Opportunité économique", d: "Le cannabis bien encadré crée des emplois et des recettes pour l'État." },
            ].map((v) => (
              <div key={v.t}>
                <div className="font-display text-2xl text-[#4A7A3D]">{v.t}</div>
                <p className="text-[#4B4B48] mt-2">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-b border-[#E0D8CE]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="font-mono-label text-[#C4944A] mb-3">Avertissement</div>
          <p className="font-quote text-xl md:text-2xl leading-snug">« {LEGAL_DISCLAIMER} »</p>
        </div>
      </section>

      <section className="bg-[#1A1A18] text-[#FAF8F3]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <div className="font-mono-label text-[#C4944A] mb-3 flex items-center justify-center gap-2"><Mail size={14} /> Une question ?</div>
          <h2 className="font-display text-4xl md:text-5xl leading-tight">Écris-nous directement.</h2>
          <p className="text-[#FAF8F3]/80 mt-4">Remarque sur un article, proposition de tribune, invitation à un débat — nous lisons tout.</p>
          <Link to="/contact" className="inline-flex items-center gap-2 mt-8 bg-[#C4944A] text-[#1A1A18] px-8 py-4 font-mono-label hover:bg-[#FAF8F3]" data-testid="about-contact-cta">
            Page contact <ArrowRight size={14} />
          </Link>
        </div>
      </section>
    </div>
  );
}
